/** Whether the locale writes times on a 24-hour clock (pt-BR) rather than with am/pm (en-US). */
export const uses24HourClock = (locale: string): boolean => {
  try {
    return (
      new Intl.DateTimeFormat(locale, { hour: 'numeric' }).resolvedOptions()
        .hour12 === false
    );
  } catch (error) {
    return false;
  }
};
